// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Snackbar from './Snackbar';
// import OTPInput from 'react-otp-input';

// const ForgotPassword = () => {
//     const navigate = useNavigate();
//     const [email, setEmail] = useState('');
//     const [otp, setOtp] = useState('');
//     const [otpClicked, setOtpClicked] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState('');


//     const pageStyle = {
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         background: '#000',
//         color: '#fff',
//         fontFamily: 'Arial, sans-serif',
//         margin: 0,
//         padding: 0,
//         boxSizing: 'border-box',
//     };

//     const containerStyle = {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-around',
//         alignItems: 'center',
//         background: '#111',
//         padding: '20px',
//         borderRadius: '10px 0px 0px 0px',
//         boxShadow: '0 0 20px 10px rgba(143, 0, 255, 0.5)',
//         width: '100%',
//         maxWidth: '599px',
//         height: '605px',
//         textAlign: 'center',
//         margin: '85px auto',
//         boxSizing: 'border-box',
//     };

//     const formStyle = {
//         display: 'flex',
//         flexDirection: 'column',
//         width: '100%',
//     };

//     const inputStyle = {
//         width: '100%',
//         padding: '10px',
//         margin: '10px 0',
//         border: '1px solid #333',
//         borderRadius: '5px',
//         background: '#222',
//         color: '#fff',
//         boxSizing: 'border-box',
//     };

//     const buttonStyle = {
//         width: '100%',
//         padding: '10px',
//         margin: '10px 0',
//         border: 'none',
//         borderRadius: '5px',
//         background: 'linear-gradient(90deg, rgba(58,29,132,1) 0%, rgba(123,36,203,1) 100%)',
//         color: '#fff',
//         cursor: 'pointer',
//         boxSizing: 'border-box',
//     };

//     const linkStyle = {
//         color: '#a2a2ff',
//         textDecoration: 'none',
//     };

//     // const optionsStyle = {
//     //     display: 'flex',
//     //     justifyContent: 'space-between',
//     //     alignItems: 'center',
//     //     margin: '10px 0',
//     // };

//     const handleSendOtp = async () => {
//         try {
//             const response = await axios.post('http://localhost:5000/sendOtp', {
//                 email,
//             });
//             const { message, Otp1 } = response.data;
//             sessionStorage.setItem('BackendOtp', Otp1); // Save user ID in session storage
//             setSnackbarMessage(`${message}`);
//             setTimeout(() => {
//                 setSnackbarMessage('');
//                 // navigate('/forgotpassword');
//             }, 3000); // Hide snackbar after 3 seconds
//             setOtpClicked(true);
//         } catch (error) {
//             setSnackbarMessage('Please try again.');
//             setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
//         }
//     };

//     const handleSubmitOtp = async () => {
//         try {
//             const response = sessionStorage.getItem("BackendOtp")
//             if (response === otp) {
//                 setSnackbarMessage('OTP verification Successful');
//                 navigate("/changepassword");
//             }
//         } catch (error) {
//             setSnackbarMessage('Otp doesn not match. Please try again.');
//             setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
//         }
//     }

//     return (
//         <div style={pageStyle}>
//             <div style={containerStyle}>
//                 <h2>Forgot Password</h2>
//                 {
//                     !otpClicked ?
//                         <form style={formStyle} onSubmit={(e) => { e.preventDefault(); handleSendOtp(); }}>
//                             <input
//                                 type="email"
//                                 placeholder="Email Id"
//                                 style={inputStyle}
//                                 value={email}
//                                 onChange={(e) => setEmail(e.target.value)}
//                                 required= {true}
//                             />
//                             <button type="submit" style={buttonStyle} 
//                             // onClick={() => setOtpClicked(true)}
//                             >Send OTP</button>
//                         </form> :
//                         <form onSubmit={(e) => { e.preventDefault(); handleSubmitOtp(); }}>
//                             <OTPInput
//                                 value={otp}
//                                 onChange={setOtp}
//                                 numInputs={4}
//                                 renderSeparator={<span>-</span>}
//                                 renderInput={(props) => <input {...props} />}
//                             />
//                             <button type="submit" style={buttonStyle}>Submit OTP</button>
//                         </form>
//                 }
//                 <p>Don't have an account? <a href="/signup" style={linkStyle}>Sign Up</a></p>
//             </div>
//             {snackbarMessage && <Snackbar message={snackbarMessage} />}
//         </div>
//     );
// };

// export default ForgotPassword;



//axios instance 

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance5000 from '../services/5000AxiosInstance'; // Import the axios instance
import Snackbar from './Snackbar';
import OTPInput from 'react-otp-input';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [otpClicked, setOtpClicked] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const pageStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#000',
        color: '#fff',
        fontFamily: 'Arial, sans-serif',
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        background: '#111',
        padding: '20px',
        borderRadius: '10px 0px 0px 0px',
        boxShadow: '0 0 20px 10px rgba(143, 0, 255, 0.5)',
        width: '100%',
        maxWidth: '599px',
        height: '605px',
        textAlign: 'center',
        margin: '85px auto',
        boxSizing: 'border-box',
    };

    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    };

    const inputStyle = {
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: '1px solid #333',
        borderRadius: '5px',
        background: '#222',
        color: '#fff',
        boxSizing: 'border-box',
    };

    const buttonStyle = {
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: 'none',
        borderRadius: '5px',
        background: 'linear-gradient(90deg, rgba(58,29,132,1) 0%, rgba(123,36,203,1) 100%)',
        color: '#fff',
        cursor: 'pointer',
        boxSizing: 'border-box',
    };

    const linkStyle = {
        color: '#a2a2ff',
        textDecoration: 'none',
    };

    const handleSendOtp = async () => {
        try {
            const response = await axiosInstance5000.post('/sendOtp', {
                email,
            });
            const { message, Otp1 } = response.data;
            sessionStorage.setItem('BackendOtp', Otp1); // Save OTP in session storage
            setSnackbarMessage(`${message}`);
            setTimeout(() => {
                setSnackbarMessage('');
            }, 3000); // Hide snackbar after 3 seconds
            setOtpClicked(true);
        } catch (error) {
            setSnackbarMessage('Please try again.');
            setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
        }
    };

    const handleSubmitOtp = async () => {
        try {
            const backendOtp = sessionStorage.getItem('BackendOtp');
            if (backendOtp === otp) {
                setSnackbarMessage('OTP verification successful');
                setTimeout(() => {
                    setSnackbarMessage('');
                    navigate('/changepassword');
                }, 3000); // Hide snackbar after 3 seconds
            } else {
                throw new Error('OTP does not match');
            }
        } catch (error) {
            setSnackbarMessage('OTP does not match. Please try again.');
            setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
        }
    };

    return (
        <div style={pageStyle}>
            <div style={containerStyle}>
                <h2>Forgot Password</h2>
                {
                    !otpClicked ?
                        <form style={formStyle} onSubmit={(e) => { e.preventDefault(); handleSendOtp(); }}>
                            <input
                                type="email"
                                placeholder="Email Id"
                                style={inputStyle}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" style={buttonStyle}>Send OTP</button>
                        </form> :
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmitOtp(); }}>
                            <OTPInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={4}
                                renderSeparator={<span>-</span>}
                                renderInput={(props) => <input {...props} />}
                            />
                            <button type="submit" style={buttonStyle}>Submit OTP</button>
                        </form>
                }
                <p>Don't have an account? <a href="/signup" style={linkStyle}>Sign Up</a></p>
            </div>
            {snackbarMessage && <Snackbar message={snackbarMessage} />}
        </div>
    );
};

export default ForgotPassword;
